var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeinline = function SvgEyeinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.998 3.519c-2.337 0-4.21 1.065-5.572 2.332-1.354 1.256-2.26 2.76-2.688 3.793a.92.92 0 0 0 0 .712c.428 1.033 1.334 2.537 2.688 3.793 1.363 1.267 3.235 2.332 5.572 2.332 2.338 0 4.21-1.065 5.573-2.332 1.354-1.259 2.26-2.76 2.69-3.793a.92.92 0 0 0 0-.712c-.43-1.033-1.336-2.537-2.69-3.793-1.363-1.267-3.235-2.332-5.573-2.332ZM5.832 10a4.166 4.166 0 1 1 8.333 0 4.166 4.166 0 0 1-8.333 0Zm4.166-1.852A1.853 1.853 0 0 1 7.56 9.904c-.159-.052-.344.047-.338.215a2.78 2.78 0 1 0 2.896-2.896c-.168-.006-.266.176-.214.338.06.185.095.382.095.587Z",
    fill: "#252525"
  })));
};
export default SvgEyeinline;